import { writable } from 'svelte/store';

// export const user = writable({});

const storage_user = localStorage.getItem("user");

export const user = writable(storage_user ? JSON.parse(storage_user) : {}); // storage_user ? JSON.parse(storage_user) : {}

user.subscribe(value => {
    localStorage.setItem("user", JSON.stringify(value));
});